export { default as useTernaryDarkMode } from './useTernaryDarkMode';
export * from './useTernaryDarkMode';
//# sourceMappingURL=index.js.map